export default __webpack_public_path__ + "static/media/longLogoBlack.1ac3a833.png";